mutation RestoreMailerConfigs($ids: [ID!]!) {
  restoreMailerConfigs(ids: $ids) {
    id
    deletedAt
  }
}
